<template>
    <glm-layout margin-footer>
        <world-map :specials="$page.props.mapCountries" height="200px">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center h-full justify-start">
                <div class="rounded-md max-w-lg inline-block p-2 bg-grey-700 text-white mt-3">
                    <h1 class="font-bold font-serif text-3xl">
                        {{ selectedType ? getTypeName(selectedType) : 'Publications' }}
                    </h1>
                </div>
            </div>
        </world-map>

        <page-content class="mt-12">
            <ul class="w-full sm:w-3/4 divide-y">
                <li v-for="(publication, idx) in publications"
                    :key="idx"
                    class="p-2"
                >
                    <span class="block text-gray-400 text-sm">
                        {{ getTypeTagLine(publication) }}
                    </span>

                    <h4 class="">
                        <a target="_blank" :href="publication.url" class="hover:underline">
                            {{ publication.title }}
                        </a>
                    </h4>
                </li>
            </ul>
        </page-content>
    </glm-layout>
</template>

<script>
import NavBar from '@/Components/NavBar'
import GlmLayout from '@/Layouts/GlmLayout'
import WorldMap from '@/Components/WorldMap'
import PageContent from '@/Components/PageContent'

export default {
    components: {
        PageContent,
        WorldMap,
        GlmLayout,
        NavBar,
    },

    props: [
        'publications',
        'types',
        'selectedType',
    ],

    methods: {
        getTypeTagLine (publication) {
            let line = ''

            switch (publication.type) {
                case 'policy_brief':
                    line = 'G²LM|LIC Policy Brief'
                    break
                case 'synthesis_paper':
                    line = 'G²LM|LIC Synthesis Paper'
                    break
                case 'working_paper':
                    line = 'G²LM|LIC Working Paper'
                    break
                case 'published_articles':
                    line = 'G²LM|LIC Published Article'

                    return line
                case 'further_papers':
                    line = 'Further Paper'

                    return line
            }

            return line + ' No. ' + publication.number
        },

        getTypeName (type) {
            let name = ''

            switch (type) {
                case 'policy_brief':
                    name = 'Policy Briefs'
                    break
                case 'synthesis_paper':
                    name = 'Synthesis Papers'
                    break
                case 'working_paper':
                    name = 'Working Papers'
                    break
                case 'published_articles':
                    name = 'Published Articles'
                    break
                case 'further_papers':
                    name = 'Further Papers'
                    break
            }

            return name
        },
    }
}
</script>
